/**
 * External dependencies
 */
import { tns } from 'tiny-slider/src/tiny-slider.js';

const wrappers = document.querySelectorAll( '.gallery' );
let tnsGallery = null;

wrappers.forEach( function( wrapper, key ) {
    if ( 0 === wrappers.length ) return;
    wrapper.setAttribute( 'id', 'gallery-' + key ); 
    tnsGallery = tns( {
		autoHeight: true,
		mouseDrag: true,
		loop: false,
		items: 1,
		container: wrapper.querySelector( '.gallery__container' ),
		speed: 400,
		swipeAngle: false,
		prevButton: '#gallery-' + key + ' .gallery__controls-prev',
		nextButton: '#gallery-' + key + ' .gallery__controls-next',
		navContainer: '#gallery-' + key + ' .gallery__nav',
	} );
} );